<div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" *transloco="let translate">
  <div fxFlex="100" class="train" fxLayout="column" fxLayoutGap="8px">
    <div fxFlex="100" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start">
      <div fxFlex class="train__id" fxLayoutAlign="start center" fxLayoutGap="4px">
        <span>{{ trainInfo?.trainIdOperator }}</span>
        @if (trainInfo?.trainType === 'CUSTOMER') {
          <img src="/assets/icons/star.svg" class="svg-to-warning" alt="Special train" />
        }
      </div>
      <div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="8px">
        @if (trainInfo?.category === 'EXPORT') {
          <div>
            {{ trainInfo?.cutoff ? translate(TRANSLOCO_PREFIX + '.train.cutoff') : null }}
            {{ trainInfo?.cutoff | egDate: 'date-time' }}
          </div>
        }
        <div>
          {{ trainInfo?.arrivalTime ? translate(TRANSLOCO_PREFIX + '.train.plannedArrival') : null }}
          {{ trainInfo?.arrivalTime | egDate: 'date-time' }}
        </div>
      </div>
    </div>
    <div fxFlex="100" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
      @if (trainInfo?.trainStatus || isAdmin) {
        <div fxFlex="20" fxLayoutAlign="start center">
          @if (trainInfo?.trainStatus) {
            <eg-pill [value]="trainInfo?.trainStatus" translationPrefix="support.trainStatus." [colors]="trainStatusColors"></eg-pill>
          }
        </div>
      }
      <div fxFlex fxLayoutAlign="end center" class="train__text">
        {{ trainInfo?.startingAddressCode }} - {{ trainInfo?.destinationAddressCode }}
      </div>
    </div>
    @if (trainInfo?.trainStatus || isAdmin) {
      <div fxFlex="100" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex fxLayoutGap="8px" fxLayoutAlign="end center">
          <rmb-capacity-pill [train]="trainInfo" [isAdmin]="isAdmin" type="capacity"></rmb-capacity-pill>
          <rmb-capacity-pill [train]="trainInfo" [isAdmin]="isAdmin" type="weight"></rmb-capacity-pill>
        </div>
      </div>
    }
    <div fxFlex="100" class="train__expand" (click)="onExpand(trainInfo.id)">
      {{ expanded ? translate(TRANSLOCO_PREFIX + '.train.hideContainers') : translate(TRANSLOCO_PREFIX + '.train.showContainers') }}
    </div>

    @if (expanded) {
      <div fxLayout="column" fxLayoutAlign="center start" fxFlex="100">
        @for (row of visibleRows; track $index; let i = $index) {
          <div fxFlex="100" fxLayout="row">
            @for (dispoOrder of row; track dispoOrder.id) {
              <rmb-train-card-containers [dispoOrder]="dispoOrder" [isAdmin]="isAdmin"></rmb-train-card-containers>
            }
          </div>
        }
      </div>
      @if (hasMoreRows) {
        <div fxFlex="100" class="train__expand" (click)="onShowMore()">
          {{ translate(TRANSLOCO_PREFIX + '.train.showMore') }}
        </div>
      }
    }
  </div>
</div>
